/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Current lifecycle status of the deployment. Poll until it reaches a
 *
 * @remarks
 * terminal state: ready (serving), failed, skipped, superseded, stopped,
 * or cancelled.
 */
export const DeploymentStatus = {
  Pending: "pending",
  Starting: "starting",
  Building: "building",
  Deploying: "deploying",
  Network: "network",
  Finalizing: "finalizing",
  Ready: "ready",
  Failed: "failed",
  Skipped: "skipped",
  AwaitingApproval: "awaiting_approval",
  Stopped: "stopped",
  Superseded: "superseded",
  Cancelled: "cancelled",
} as const;
/**
 * Current lifecycle status of the deployment. Poll until it reaches a
 *
 * @remarks
 * terminal state: ready (serving), failed, skipped, superseded, stopped,
 * or cancelled.
 */
export type DeploymentStatus = ClosedEnum<typeof DeploymentStatus>;

/** @internal */
export const DeploymentStatus$inboundSchema: z.ZodNativeEnum<
  typeof DeploymentStatus
> = z.nativeEnum(DeploymentStatus);
/** @internal */
export const DeploymentStatus$outboundSchema: z.ZodNativeEnum<
  typeof DeploymentStatus
> = DeploymentStatus$inboundSchema;
